import React, { useState, useEffect } from "react";

const SidebarDropdown = ({
  getUniqueStates,
  getLocationsForState,
  getSitesForLocation,
  onSelectSite,
}) => {
  const states = getUniqueStates();
  const [expandedState, setExpandedState] = useState(null);
  const [autoSelected, setAutoSelected] = useState(false);

  // On initial load: expand first state and auto-select first site
  useEffect(() => {
    if (!autoSelected && states.length > 0) {
      const firstState = states[0];
      const locations = getLocationsForState(firstState);
      if (locations.length > 0) {
        const firstLocation = locations[0];
        const sites = getSitesForLocation(firstState, firstLocation);
        if (sites.length > 0) {
          const firstSite = sites[0];
          setExpandedState(firstState);
          onSelectSite(firstState, firstLocation, firstSite);
          setAutoSelected(true); // prevent this from running again
        }
      }
    }
  }, [states, autoSelected]);

  const toggleState = (state) => {
    setExpandedState((prev) => (prev === state ? null : state));
  };

  return (
    <div className="w-64 text-black border-r border-gray-300 bg-white">
      <div className="h-full overflow-y-auto p-4">
        <ul>
          {states.map((state, idx) => (
            <li key={idx} className="mb-2">
              <div
                className="font-bold text-lg mb-1 cursor-pointer flex justify-between items-center hover:bg-gray-100 p-2 rounded"
                onClick={() => toggleState(state)}
              >
                <span>{state}</span>
                <span>{expandedState === state ? "▲" : "▼"}</span>
              </div>

              {expandedState === state && (
                <ul className="ml-4">
                  {Array.from(
                    new Set(
                      getLocationsForState(state)
                        .flatMap((location) =>
                          getSitesForLocation(state, location).map((site) => ({
                            location,
                            site,
                            key: `${location}-${site}`,
                          }))
                        )
                        .map((item) => item.key)
                    )
                  ).map((uniqueKey) => {
                    const [location, site] = uniqueKey.split("-");
                    return (
                      <li
                        key={uniqueKey}
                        className="p-2 hover:bg-gray-200 rounded cursor-pointer"
                        onClick={() => onSelectSite(state, location, site)}
                      >
                        {location} - {site}
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SidebarDropdown;
